module.exports = __webpack_public_path__ + "img/auth.316fe215.jpg";